import { render, staticRenderFns } from "./SendMessageConfiguration.vue?vue&type=template&id=50ad537a&"
import script from "./SendMessageConfiguration.vue?vue&type=script&lang=js&"
export * from "./SendMessageConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports